import { render } from "./ControlCenterModule.vue?vue&type=template&id=140c3118&ts=true&lang=true"
import script from "./ControlCenterModule.vue?vue&type=script&lang=ts"
export * from "./ControlCenterModule.vue?vue&type=script&lang=ts"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__